function showMess (_this, title, mess, icon, toast, time) {
  _this.$bvToast.toast(mess, {
    title: title,
    autoHideDelay: time,
    variant: icon,
    toaster: toast,
    solid: true,
    appendToast: true
  })
}

export { showMess }
